import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import useAuthenticationStore, { AuthenticationViews } from "./Store";
import ForgotPassword from "./ForgotPassword";

const ForgottonPasswordContainer: React.FC = () => {
  const { state, dispatch, resendPasswordResetCode, verifyPhoneForPasswordReset } = useAuthenticationStore()
  const {
    emailOrPhone,
    verificationCode,
    serverError,
    isLoading,
    resendWait,
  } = state

  const navigate = useNavigate()

  const setVerificationCode = (newVerificationCode: string) => {
    dispatch({ type: 'SET_VERIFICATION_CODE', payload: newVerificationCode })
  }

  useEffect(() => {
    if (!emailOrPhone) {
      navigate('../' + AuthenticationViews.login)
    }
  }, [emailOrPhone, navigate])

  return (
    <ForgotPassword
      emailOrPhone={emailOrPhone}
      verificationCode={verificationCode}
      serverError={serverError}
      isLoading={isLoading}
      resendWait={resendWait}
      resendPasswordResetCode={resendPasswordResetCode}
      setVerificationCode={setVerificationCode}
      verifyPhoneForPasswordReset={verifyPhoneForPasswordReset}
    />
  )
}

export default ForgottonPasswordContainer